// ============================================================
// 鉴权接口（shared）—— 按当前端 APP_TARGET 自动拼前缀
// login 由各端 apps/<target>/api/auth.ts 注入登录页；
// logout 在 shared 布局 Navbar 等处共用。
// ============================================================
import { http } from "@shared/utils/request";
import { APP_TARGET } from "@shared/utils/storage";

export function logout(): Promise<void> {
    return http.post<void>(`/${APP_TARGET}/logout`);
}
